import { useMemo } from 'react';

import type { CommentKeys } from '../../../comments/api/cache/comment-keys';
import { createCommentKeys } from '../../../comments/api/cache/comment-keys';
import type { CommentsApi } from '../../../comments/comments-api-context';
import { useApplicationFetchers } from '../../../fetchers/use-application-fetchers';

export const profileTaskCommentKeys: CommentKeys = createCommentKeys('profile-task');

export const useProfileTaskCommentsApi = (): CommentsApi => {
    const { profileTaskComments } = useApplicationFetchers();
    return useMemo(() => ({ fetchers: profileTaskComments, keys: profileTaskCommentKeys }), [profileTaskComments]);
};
